import { Button as MuiButton } from "@mui/material";
import * as React from "react";
import "swiper/css";

type Props = {
  buttonText: string;
  target?: React.HTMLAttributeAnchorTarget;
  href?: string;
  children?: React.ReactElement | React.ReactElement[];
};

export default function Button({
  buttonText,
  href,
  target = "_self",
  children,
  ...extraProps
}: Props): React.ReactElement {
  if (href) {
    return (
      <a href={href} target={target} className="no-underline">
        <MuiButton {...extraProps}>{buttonText}</MuiButton>
      </a>
    );
  }

  return <MuiButton {...extraProps}>{children || buttonText}</MuiButton>;
}
